<script>
import {
    ArrowUpIcon,
    ArrowRightIcon
} from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

/**
 * Page-privacy component
 */
export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon,
        ArrowRightIcon
    }
}
</script>

<template>
<div>
    <Navbar :nav-light="true" />

    <!-- Hero Start -->
    <section class="bg-half bg-primary d-table w-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="page-next-level">
                        <h4 class="title text-white"> {{$t('member.title')}} </h4>
                        <ul class="list-unstyled mt-4">
                            <li class="list-inline-item h6 date text-white"> {{$t('member.description')}}</li>
                        </ul>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Start Privacy -->
    <section class="section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-9">
                    <div class="card shadow rounded border-0">
                        <div class="card-body">
                            <h3 class="card-title">{{$t('member.overview.title')}}</h3>
                            <p v-html="$t('member.overview.content')"></p>
                            <h5 class="card-title">{{$t('member.overview.title1')}}</h5>
                            <p><arrow-right-icon class="fea icon-sm mr-2"></arrow-right-icon><span v-html="$t('member.overview.content1')"></span></p>
                            <p><arrow-right-icon class="fea icon-sm mr-2"></arrow-right-icon><span v-html="$t('member.overview.content2')"></span></p>
                          <h5 class="card-title">{{$t('member.overview.title3')}}</h5>
                          <p><arrow-right-icon class="fea icon-sm mr-2"></arrow-right-icon>{{$t('member.overview.content3')}}</p>
                          <h5 class="card-title">{{$t('member.overview.title4')}}</h5>
                          <p><arrow-right-icon class="fea icon-sm mr-2"></arrow-right-icon>{{$t('member.overview.content4')}}</p>
                          <h5 class="card-title">{{$t('member.overview.title5')}}</h5>
                          <p>{{$t('member.overview.content5')}}</p>
                          <p v-html="$t('member.overview.desc1')"></p>
                          <p v-html="$t('member.overview.desc2')"></p>
                          <p v-html="$t('member.overview.desc3')"></p>
                          <p v-html="$t('member.overview.desc4')"></p>

                          <h5 class="card-title mt-5">{{$t('member.faq.title')}}</h5>
                          <div class="faq-content mt-4">
                            <div class="accordion" id="accordionExampleone">
                              <b-card no-body class="mb-2 border-0  rounded " v-for="(item ,i) in $t('member.faq.list')">
                                <b-card-header class="border-0 bg-light p-3 pr-5">
                                  <a class="faq position-relative text-dark" v-b-toggle="('accordion-'+(i+1))" href="javascript: void(0);">
                                    <h6 class="title mb-0 text-black"> <i class="mdi mdi-comment-question-outline"> </i> <b>{{item.q}}</b> </h6>
                                  </a>
                                </b-card-header>
                                <b-collapse v-bind:id="('accordion-'+(i+1))" visible accordion="my-accordion" role="tabpanel">
                                  <b-card-body class="px-2 py-4">
                                    <p class="mb-0 faq-ans">{{item.a}}</p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </div>

                        </div>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- End Privacy -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>
